import { HStack, Icon, Text } from "@chakra-ui/react";
import React from "react";
import { IconType } from "react-icons";

export default function IconWithText({
  text,
  icon,
}: {
  text: string;
  icon: IconType;
}) {
  return (
    <HStack w="100%">
      <Icon color="blue.700" as={icon}></Icon>
      <Text fontSize="sm" color="gray.800">
        {text}
      </Text>
    </HStack>
  );
}
